import { DatePipe } from '@angular/common';
import { DateComparisonType } from 'shared/enums/dates.enum';

// Returns true if the targetDate is older/newer (depending on comparison value) than the specified number of days ago
export function compareDateWithDaysAgo(
    targetDate: string | Date | null | undefined,
    days: number,
    comparison: DateComparisonType,
): boolean {
    if (!targetDate) {
        return false;
    }

    const date = new Date(targetDate);
    const now = new Date();
    const threshold = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);

    return comparison === DateComparisonType.OLDER ? date < threshold : date > threshold;
}

/**
 * Formats an input date to a given format using Angular's DatePipe
 * @param date Date object to format
 * @param format Date format string (ex: yyyy-MM-dd)
 * @returns a string representing the input date formatted using the input format
 */
export function formatDate(date: string | number | Date | undefined, format: string) {
    return new DatePipe('en-US').transform(date, format);
}

/**
 * Strips the time component of a date.
 * @param date Date object to modify
 */
export function stripTimeComponent(date: Date) {
    date.setUTCHours(0, 0, 0, 0);
}

/**
 * Checks if date1 is before date2. This function checks down to the millisecond level, you might want to call stripTimeComponent before this.
 * @param date1 Source date
 * @param date2 Date to check against
 * @param allowEqual If true, the function returns true for dates that are equal. Otherwise, the date1 must be strictly before date2
 * @returns boolean determining if date1 is before date2
 */
export function isDateBefore(date1: Date, date2: Date, allowEqual: boolean) {
    if (allowEqual && date1.getTime() === date2.getTime()) {
        return false;
    }

    if (date1.getTime() <= date2.getTime()) {
        return true;
    }

    return false;
}

/**
 * Checks if date1 is after date2. This function checks down to the millisecond level, you might want to call stripTimeComponent before this.
 * @param date1 Source date
 * @param date2 Date to check against
 * @param allowEqual If true, the function returns true for dates that are equal. Otherwise, the date1 must be strictly after date2
 * @returns boolean determining if date1 is after date2
 */
export function isDateAfter(date1: Date, date2: Date, allowEqual: boolean) {
    if (allowEqual && date1.getTime() === date2.getTime()) {
        return false;
    }

    if (date1.getTime() >= date2.getTime()) {
        return true;
    }

    return false;
}
